<template>
  <transition v-if="showViewTypeMission" mode="out-in" name="fade">
    <router-view></router-view>
  </transition>
  <div v-else>
    <main class="main-wrapper flex-grow-1 with-footer">
      <div ref="learnHeader">
        <ViewHeader
            :basicData="basicData" :todayDate="todayDate"
        ></ViewHeader>
      </div>
      <!-- subtabs -->
      <ViewSubTabWaiting v-if="!learStartStatus"
                         :setTabFixed="setTabFixed"
                         @setSubTab="setSubTab"
      ></ViewSubTabWaiting>
      <ViewSubTab v-else
                  :setTabFixed="setTabFixed"
                  @setSubTab="setSubTab"
      ></ViewSubTab>
      <div v-if="basicData && learStartStatus" class="">
        <component :is="tabType"
                   ref="contentsComp"
                   :basicData="basicData"
                   :dataLoadState="dataLoadState"
                   :lessonData="lessonData"
                   :lessonsList="lessonsList"
                   :nextLessonData="nextLessonData"
                   :nextLessonName="nextLessonName"
                   :notiFicationProgressRate="notiFicationProgressRate"
                   :notiFicationShow="notiFicationShow"
                   :sectionList="sectionList"
                   :teacher="basicData.teacher"
                   :todayDate="todayDate"
                   @setExamineeId="setExamineeId"
                   @setMissionId="setMissionId"
                   @setNextLesson="setNextLesson"
                   @setSurveyId="setSurveyId"
        ></component>

        <div v-if="!hasMyReview && writePermission === true" class="d-flex justify-content-end mgt-16 lesson-fixed-button">
          <button class="mdc-button mdc-button--raised mdc-button--leading h-48 bg-mainBtn b-radius24 min-w-136 t-color-white mgr-30" @click="goToReview" @keypress="goToReview">
            <span class="mdc-button__ripple"></span>
            <i aria-hidden="true" class="material-icons mdc-button__icon font-24 h-24 w-24">create</i>
            <span class="mdc-button__label t-body2 font-m">{{ $t('30081') }}</span>
          </button>
        </div>
      </div>

    </main>
    <transition v-if="screenTypeName !== 'MicroDegreeView'" mode="out-in" name="fade">
      <ViewFooter
          :basicData="basicData"
          :examineeId="examineeId"
          :missionId="missionId"
          :nextLessonData="nextLessonData"
          :setTabFixed="setTabFixed"
          :surveyId="surveyId"
          :tabType="tabType"
          :todayDate="todayDate"
      ></ViewFooter>
    </transition>
  </div>
</template>

<script>
/**
 * 나의 학습 상세 메인 컴포넌트(my learning view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import microLearnApi from '@/api/microLearnApi.js'
import ViewHeader from './view/Header.vue'
import ViewFooter from './view/Footer.vue'
import ViewSubTab from './view/SubTab.vue'
import ViewSubTabWaiting from './view/SubTabWaiting.vue'
import ViewLesson from './view/Lesson.vue'
import ViewExam from './view/Exam.vue'
import ViewMission from './view/Mission.vue'
import ViewQuestion from './view/Question.vue'
import ViewSurvey from './view/Survey.vue'
import microDegreeApi from "@/api/microDegreeApi";
import {storageConstants} from "@/utils/enum/StorageConstants";
import {MDCDialog} from "@material/dialog";

const showListRouterChild = ['LessonQuestion', 'MicroDegreeViewQuestion', 'MicroMissionUpdate', 'FinalMicroExamFeedback', 'MicroMission', 'FinalMicroExamResult', 'FinalMicroExamTake', 'FinalMicroExamIntro', 'FinalMicroExamFeedback', 'FinalMicroExamResult', 'MicroExamTake', 'MicroExamIntro', 'MicroMissionSubmit', 'MicroMissionViewSubmit', 'MicroExamResult', 'MicroExamFeedback', 'MicroExamFeedbackIssue', 'MicroExamFeedbackQuestion', 'FinalMicroExamFeedbackQuestion'];

export default {
  data() {
    return {
      lessonData: null,
      lessonsList: [],
      sectionList: [],
      dataLoadState: false,
      sectionName: '',
      nextLessonName: "",
      nextProgressionId: null,
      sectionId: 0,
      lessonCount: 0,
      lessonRate: 0,
      notiFicationProgressRate: 0,
      notiFicationShow: false,
      progressionId: 0,

      tabType: 'ViewLesson',
      basicData: null,
      setTabFixed: false,
      nextLessonData: null,

      learStartStatus: false,
      examineeId: 0,
      missionId: 0,
      surveyId: 0,
      degreeId: 0,
      showViewTypeMission: false,
      screenTypeName: null,
      todayDate: this.$moment(new Date()).valueOf(),
      isMember: JSON.parse(localStorage.getItem(storageConstants.userParams)).userId,
      hasMyReview: false,
      writePermission: false
    }
  },

  components: {
    ViewHeader, ViewFooter, ViewSubTab, ViewSubTabWaiting, ViewLesson, ViewExam, ViewMission, ViewQuestion, ViewSurvey
  },

  mixins: [topAppBarMixin],

  watch: {
    $route() {
      this.statusTab = this.$route.query.status;
      let getExamResult = this.$route.query.examresult;
      if(getExamResult === 'getscore') {
        this.fetchData();
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    document.querySelector(".mdc-dialog.mdc-new-dialog").classList.remove("mdc-dialog--open");
    next();
  },

  updated() {
    this.screenTypeName = this.$route.name;
  },

  beforeMount () {
    if(showListRouterChild.includes(this.$router.currentRoute.name)) {
      this.showViewTypeMission = true;
    } else {
      this.fetchData();
    }
  },

  mounted() {
    this.statusTab = this.$route.query.status;
  },

  methods: {
    // 텝 설정(set tab)
    setSubTab(type) {
      this.tabType = type;
    },

    // 기본정보 API 호출 및 데이터 설정(get data)
    fetchData() {
      let responseData = null
      let params = this.setParams()
      //this.$showLoading()

      // get learn basic information
      microLearnApi.learnViewBasic(params).then((response) => {
        this.basicData = response.data.data;
        this.degreeId = this.basicData.degreeId;
        this.fetchReviewData();
        this.fetchAuthPermission();
        // set learning status
        microLearnApi.learnStart(params).then((response) => {
          this.learStartStatus = true;
          this.fetchLessonData();
        })

        //this.$hideLoading()
      }).catch((err) => {
        responseData = err.response.data.meta
        this.$error({content: responseData.errMsg}).then(() => {})
      })

    },

    // 차시정보 API 호출 및 데이터 설정(get lesson list data)
    fetchLessonData() {
      this.lessonsList = [];
      let params = this.setParams();

      //차시 정보
      this.$showLoading(this.$refs.lessonList);

      microLearnApi
          .learnViewCourses(params)
          .then((response) => {
            this.lessonData = response.data.data;
            // 과정의 차시 정보만 병합(merge lesson data)
            _.each(this.lessonData, (course) => {
              this.sectionList = this.sectionList.concat(course.sections);
              this.progressionId = course.progressionId;
              _.each(course.sections, (lesson) => {
                this.sectionId = lesson.id;
                this.lessonsList = this.lessonsList.concat(lesson.lessons);
                this.lessonsList = this.lessonsList.filter(function (a) {
                  return !this[a.id] && (this[a.id] = true);
                }, Object.create(null));
                this.lessonCount += parseInt(lesson.lessonCount);
              })
            });
            this.lessonsList.forEach((value, index) => {
              this.lessonRate += parseInt(value.rate);
            });
            this.$hideLoading();
            this.notiFicationProgressRate = this.lessonRate / this.lessonCount;
            if (this.notiFicationProgressRate < 100) {
              this.notiFicationShow = true;
            }
            this.dataLoadState = true;
          });

      // get next lesson
      microLearnApi.learnLessonNext(params).then((response) => {
        this.nextLessonData = response.data.data;

        if (this.nextLessonData) {
          this.nextLessonName = this.nextLessonData.name;
          this.nextProgressionId = this.nextLessonData.progressionId;
          // this.setNextLesson();
        }
        // this.setNextLesson();
      });
    },

    //파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId,
        degreeId: this.degreeId,
      }
      return params
    },

    // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
    scrollMove(el) {
      if (parseInt(el.scrollTop) >= parseInt(this.$refs.learnHeader.offsetHeight)) {
        this.setTabFixed = true
      } else {
        this.setTabFixed = false
      }
    },

    goToReview() {
      this.$router.push({
        name: "MicroDegreeReviewPost",
        params: { id: this.degreeId}
      })
    },

    fetchAuthPermission() {
      let params = this.setParams();
      microDegreeApi.authPermission(params).then((reponse) => {
        this.writePermission = reponse.data.data.registrationAuth;
      }).catch((err) => {})
    },

    fetchReviewData() {
      const params = {
        degreeId: this.degreeId,
      };
      microDegreeApi.learnOnlineViewReview(params).then((response) => {
        this.hasMyReview = _.some(response.data.data.content, (member) => {
          return member.reviewer.email === this.isMember
        })
      }).catch((err) => {});
    },

    // set next lesson
    setNextLesson(data) {
      this.nextLessonData = data
    },

    // set examinee
    setExamineeId(data) {
      this.examineeId = data
    },

    // set mission
    setMissionId(data) {
      this.missionId = data
    },

    // set survey
    setSurveyId(data) {
      this.surveyId = data
    }
  }
}
</script>
